import { render } from "./BasePageFilters.vue?vue&type=template&id=284bb8d1"
import script from "./BasePageFilters.vue?vue&type=script&lang=js"
export * from "./BasePageFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/helpers/BasePageFilters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "284bb8d1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('284bb8d1', __exports__)) {
    api.reload('284bb8d1', __exports__)
  }
  
  module.hot.accept("./BasePageFilters.vue?vue&type=template&id=284bb8d1", () => {
    api.rerender('284bb8d1', render)
  })

}


export default __exports__